__turbopack_context__.v({
  "button__iw7VZ": "_NR-oq_button__iw7VZ",
  "cardContent": "_NR-oq_cardContent",
  "freeBox__uyYfI": "_NR-oq_freeBox__uyYfI",
  "freeBox__zirLo": "_NR-oq_freeBox__zirLo",
  "h4__yQaql": "_NR-oq_h4__yQaql",
  "p__cnPtZ": "_NR-oq_p__cnPtZ",
  "svg__aYj3G": "_NR-oq_svg__aYj3G",
  "svg__kCxQ6": "_NR-oq_svg__kCxQ6",
  "svg__sQoS": "_NR-oq_svg__sQoS",
});
